// Constants for Kijabe chat
export const HEALTH_DESK_SENDER = "HLTHDSK";
